var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 8.83366C16.6663 13.8337 9.99967 18.8337 9.99967 18.8337C9.99967 18.8337 3.33301 13.8337 3.33301 8.83366C3.33301 7.06555 4.03539 5.36986 5.28563 4.11961C6.53587 2.86937 8.23156 2.16699 9.99967 2.16699C11.7678 2.16699 13.4635 2.86937 14.7137 4.11961C15.964 5.36986 16.6663 7.06555 16.6663 8.83366Z",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.333C11.3807 11.333 12.5 10.2137 12.5 8.83301C12.5 7.4523 11.3807 6.33301 10 6.33301C8.61929 6.33301 7.5 7.4523 7.5 8.83301C7.5 10.2137 8.61929 11.333 10 11.333Z",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d145dfa4027d3f1d61b379a605fec870.svg";
export { ForwardRef as ReactComponent };